import React from 'react';
import Sidebar from './Sidebar';

function SidebarWrapper(): JSX.Element {
  return <Sidebar />;
}

export default SidebarWrapper;
